/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ContextInfo from "../../Teilnahmen/Utils/ContextInfo";

export default class ArtikelUrlsBuilder {
    public static buildArtikelsammlungUrl(seminarId?: string, seminarreiheId?: string): string {
        return `${this.getBaseUrl(this.getContextInfo(seminarId, seminarreiheId))}/artikelsammlung`;
    }

    public static buildArtikelUrl(artikelId: string, seminarId?: string, seminarreiheId?: string, subView = ""): string {
        return `${this.getBaseUrl(this.getContextInfo(seminarId, seminarreiheId))}/artikel/${artikelId}${subView}`;
    }

    private static getContextInfo(seminarId?: string, seminarreiheId?: string): ContextInfo | undefined {
        if (seminarreiheId) {
            return { context: "seminarreihe", contextId: seminarreiheId }
        }

        if (seminarId) {
            return { context: "seminar", contextId: seminarId };
        }

        return undefined;
    }

    private static getBaseUrl(contextInfo?: ContextInfo) {
        if (contextInfo) {
            const { context, contextId } = contextInfo;
            return `/${context}/${contextId}`;
        }

        return "";
    }
}
